/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="md" variant="full" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const parentsProfileTableData = (attendanceData) => {
  if (attendanceData === undefined) {
    return parentsProfileTableData;
  }
  const attendanceList = Array.isArray(attendanceData) ? attendanceData : [];

  const getStudentNames = (attendance) => {
    if (attendance?.student?.name) return attendance.student.name;
    if (attendance?.students?.name) return attendance.students.name;

    const classSessionStudents = Array.isArray(attendance?.classSession?.students)
      ? attendance.classSession.students
      : [];
    const names = classSessionStudents.map((student) => student?.name).filter(Boolean);

    return names.length > 0 ? names.join(", ") : "N/A";
  };

  const rows = attendanceList.map((attendance, index) => ({
    "Topic Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {attendance.topicCovered || "N/A"}
      </ArgonTypography>
    ),
    Date: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {attendance.attendanceTime
          ? new Date(attendance.attendanceTime).toLocaleDateString()
          : "N/A"}
      </ArgonTypography>
    ),
    "Student Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {getStudentNames(attendance)}
      </ArgonTypography>
    ),
  }));

  return {
    columns: parentsProfileTableData.columns,
    rows,
  };
};

parentsProfileTableData.columns = [
  { name: "Student Name", align: "center" },
  { name: "Topic Name", align: "center" },
  { name: "Date", align: "center" },
];

parentsProfileTableData.rows = [
  {
    Date: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"24 july 2023"}
      </ArgonTypography>
    ),
    "Topic Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Mathematics"}
      </ArgonTypography>
    ),
    "Student Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"John Doe"}
      </ArgonTypography>
    ),
  },
];

export default parentsProfileTableData;
